import { createActionGroup, props } from '@ngrx/store';

export const uiActions = createActionGroup({
  source: '[UI] UI State',
  events: {
    'Set Sidebar Collapsed': props<{ collapsed: boolean }>(),
  },
});
